// frontend/src/services/subscriptionAPI.js
import { api } from './api';

export const subscriptionAPI = {
  // Get current user subscription
  getCurrentSubscription: async () => {
    try {
      const response = await api.get('/subscriptions/current');
      return response.data;
    } catch (error) {
      console.warn('Failed to fetch subscription:', error);
      // Return default free subscription if API fails
      return {
        tier: 'free',
        status: 'active',
        search_limit: 5,
        searches_used: 0,
        searches_remaining: 5,
        billing_interval: 'month',
        annual_discount_applied: false
      };
    }
  },

  // Get all available subscription plans
  getSubscriptionPlans: async () => {
    try {
      const response = await api.get('/subscriptions/plans');
      return response.data;
    } catch (error) {
      console.warn('Failed to fetch subscription plans:', error);
      // Return default plans if API fails
      return {
        plans: [
          {
            tier: 'free',
            name: 'Free Trial',
            monthly_cost: 0,
            annual_cost: 0,
            search_limit: 50,
            features: ['Vehicle profile management and basic maintenance tracking', 'Promotional free trial (30-60 days)', 'Basic vehicle information'],
            popular: false
          },
          {
            tier: 'basic',
            name: 'Basic',
            monthly_cost: 8.99,
            annual_cost: 79.90,
            search_limit: 200,
            features: ['Vehicle profile management and basic maintenance tracking', 'Vehicle profile management', 'Basic maintenance tracking'],
            popular: false
          },
          {
            tier: 'professional',
            name: 'Professional',
            monthly_cost: 29.99,
            annual_cost: 249.90,
            search_limit: -1,
            features: ['AI powered recommendations and Document Upload', 'AI diagnostics', 'Advanced tools'],
            popular: true
          }
        ]
      };
    }
  },

  // Get usage statistics
  getUsageStats: async () => {
    try {
      const response = await api.get('/subscriptions/usage');
      return response.data;
    } catch (error) {
      console.warn('Failed to fetch usage stats:', error);
      // Return default stats if API fails
      return {
        searches_today: 0,
        searches_this_month: 0,
        vehicles_tracked: 0,
        recommendations_generated: 0,
        jobs_created: 0,
        quotes_sent: 0
      };
    }
  },

  // Check search limit
  checkSearchLimit: async () => {
    try {
      const response = await api.post('/subscriptions/check-limit');
      return response.data;
    } catch (error) {
      console.warn('Failed to check search limit:', error);
      // Return default response if API fails
      return { can_search: true };
    }
  },

  // Increment search usage
  incrementSearchUsage: async () => {
    try {
      const response = await api.post('/subscriptions/increment-usage');
      return response.data;
    } catch (error) {
      console.warn('Failed to increment usage:', error);
      // Return default response if API fails
      return { searches_used: 0 };
    }
  },

  // Get billing history
  getBillingHistory: async () => {
    try {
      const response = await api.get('/subscriptions/billing-history');
      return response.data;
    } catch (error) {
      console.warn('Failed to fetch billing history:', error);
      return { subscription_changes: [] };
    }
  },

  // Cancel subscription
  cancelSubscription: async () => {
    try {
      const response = await api.post('/subscriptions/cancel');
      return response.data;
    } catch (error) {
      console.warn('Failed to cancel subscription:', error);
      throw error; // Re-throw this one as it's user-initiated
    }
  },

  // Get tier features
  getTierFeatures: async (tier) => {
    try {
      const response = await api.get(`/subscriptions/features/${tier}`);
      return response.data;
    } catch (error) {
      console.warn('Failed to fetch tier features:', error);
      return { tier, features: [] };
    }
  }
};
